import React from 'react';
import PropTypes from 'prop-types';

import RowFullPlus from './types/full-plus/RowFullPlus';
import RowFull from './types/full/RowFull';
import RowPartial from './types/partial/RowPartial';
import RowColumn from './types/column/RowColumn';
import RowHistory from './types/history/RowHistory';
import RowShared from './types/shared/RowShared';
import RowCart from './types/cart/RowCart';

function RowsFactory({ type, options = {} }) {
  const componentRows = {
    'Full#': RowFullPlus,
    'Full': RowFull,
    'Partial': RowPartial,
    'History': RowHistory,
    'Column': RowColumn,
    'Shared': RowShared,
    'Cart': RowCart
  };

  return React.createElement(componentRows[type], options);
}

RowsFactory.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.object
}

export default RowsFactory;
